// Shared submission round status helpers.
// Mirrors slaStatusDisplay.ts — reuses the same Tailwind class token convention.

export type SubmissionRoundState =
  | "awaiting_tenant_upload"
  | "awaiting_rdd_review"
  | "resubmission_required"
  | "approved"
  | "none";

export const STATE_LABEL: Record<SubmissionRoundState, string> = {
  awaiting_tenant_upload: "Awaiting Tenant Upload",
  awaiting_rdd_review: "Awaiting RDD Review",
  resubmission_required: "Resubmission Requested",
  approved: "Approved",
  none: "",
};

// Class strings mirror STATUS_COLORS / STATUS_BADGE from slaStatusDisplay.ts
// amber → warning tokens, red → error tokens, green → success tokens, gray → black tokens
export const STATE_COLOR: Record<SubmissionRoundState, string> = {
  awaiting_tenant_upload: "text-black-80 bg-black-10 border border-black-20",
  awaiting_rdd_review: "text-black-80 bg-orange-200 border border-orange-400",
  resubmission_required: "text-error-darker bg-error-light border border-error",
  approved: "text-success-darker bg-success-light border border-success",
  none: "text-black-60 bg-black-10 border border-black-20",
};

export function roundTagText(
  roundNumber: number,
  state: SubmissionRoundState
): string {
  if (state === "none" || !roundNumber) return "";
  return `Round ${roundNumber} · ${STATE_LABEL[state]}`;
}
